import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance';

type BlobDownloadUrlResponse = {
  url: string;
};

type Params = {
  sessionId: string;
  name: string;
};

export const useGetBlobDownloadUrl = () =>
  useMutation<BlobDownloadUrlResponse, unknown, Params>(
    async ({ sessionId, name }) => {
      const params = new URLSearchParams({ name });
      const { data } = await Axios.get<BlobDownloadUrlResponse>(
        `/api/admin/session-inspector/${sessionId}/blobs/url?${params}`
      );
      return data;
    }
  );
